import { render, staticRenderFns } from "./BankingData.vue?vue&type=template&id=61a1b5f8&scoped=true&"
import script from "./BankingData.vue?vue&type=script&lang=js&"
export * from "./BankingData.vue?vue&type=script&lang=js&"
import style0 from "./BankingData.vue?vue&type=style&index=0&id=61a1b5f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1b5f8",
  null
  
)

export default component.exports